import { render, staticRenderFns } from "./driver_list.vue?vue&type=template&id=0f216593&scoped=true&"
import script from "./driver_list.vue?vue&type=script&lang=js&"
export * from "./driver_list.vue?vue&type=script&lang=js&"
import style0 from "./driver_list.vue?vue&type=style&index=0&id=0f216593&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f216593",
  null
  
)

export default component.exports